import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '../../../../@fuse/animations';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import {
    ColDef,
    GridApi,
    GridReadyEvent,
    ICellRendererParams,
} from 'ag-grid-community';
import CampaignUtils from '../../campaign/shared/campaign-utils';
import { AffiliateManageService } from './affiliate-manage.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { isEmpty } from 'lodash';
import { async } from '@angular/core/testing';
import { CreateAffiliateDialogComponent } from './create-affiliate-dialog.component';
const MAX_TABLE_HEIGHT = 520;
@Component({
    selector: 'app-affiliate-manage',
    templateUrl: './affiliate-manage.component.html',
    styleUrls: ['./affiliate-manage.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class AffiliateManageComponent implements OnInit, OnDestroy {
    columnDefs: ColDef[] = [
        {
            headerName: '#',
            valueGetter: 'node.rowIndex + 1',
            sortable: false,
            filter: false,
            resizable: false,
            width: 50
        },
        {
            field: 'gender',
            headerName: 'Danh xưng',
            valueGetter: (item) => {
                return item.data.gender === 'MALE' ? 'Anh' : 'Chị';
            },
            width: 150,
        },
        {
            field: 'fullName',
            headerName: 'Họ tên',
            width: 200,
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 250,
        },
        {
            field: 'phone',
            headerName: 'Số điện thoại',
            width: 150,
        },
        {
            field: 'code',
            headerName: 'Referral Code',
            width: 150,
        },
        {
            field: 'status',
            headerName: 'Trạng thái',
            width: 150,
            cellRenderer: AffiliateManageCellRenderer,
            cellRendererParams: {
                toggleStatus: (data) => {
                    this.handleChangeStatus(data);
                },
            },
            sortable: false,
        },
    ];
    gridApi!: GridApi;
    defaultColDef = CampaignUtils.defaultColDef;
    rowData = [];
    selectedRow = null;
    currentFilter = 'NOT_READY';
    currentPage = 0;
    fetchingData = false;
    fetchedAll = false;
    maxScrollTop = -1;
    private unsubscribeAll: Subject<any>;

    constructor(
        private affiliateManageService: AffiliateManageService,
        private matDialog: MatDialog,
        private matSnackBar: MatSnackBar
    ) {
        this.unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.reloadData();
        this.affiliateManageService.onAffiliatesChanged
            .pipe(takeUntil(this.unsubscribeAll))
            .subscribe((candidates) => {
                if (candidates.length > 0) {
                    if (this.gridApi) {
                        this.gridApi.applyTransaction({ add: candidates });
                    }
                } else {
                    this.fetchedAll = this.currentPage > 0;
                }
            });
    }

    ngOnDestroy() {
        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
    }

    handleChangeStatus(data) {
        console.log({ data });
        this.affiliateManageService.editAffiliate(data).then(() => {
            this.matSnackBar.open("Thành công", "OK", {
                verticalPosition: "top",
                duration: 2000
            });
        }).catch(() => {
            this.matSnackBar.open("Xảy ra lỗi", "OK", {
                verticalPosition: "top",
                duration: 2000
            });
        });
    }

    createAffiliate() {
        this.matDialog.open(CreateAffiliateDialogComponent, {
            panelClass: 'create-affiliate-dialog'
        }).afterClosed().subscribe((formData) => {
            if(formData) {
                this.affiliateManageService.createAffiliate(formData).then(() => {
                    this.matSnackBar.open("Tạo refferal code thành công", "OK", {
                        verticalPosition: "top",
                        duration: 2000
                    });
                    this.reloadData();
                })
            }
        })
    }

    exportCsv() {
        this.affiliateManageService.exportCsv();
        this.matSnackBar.open("Xuat file thành công", "OK", {
            verticalPosition: "top",
            duration: 2000
        })
    }


    fetchMoreData() {
        if (this.fetchingData || this.fetchedAll) {
            return;
        }

        this.currentPage++;
        this.fetchingData = true;
        this.affiliateManageService
            .getAffiliates()
            .then(() => {
                this.fetchingData = false;
            })
            .catch(() => {
                this.fetchingData = false;
                this.fetchedAll = true;
            });
    }

    reloadData(): void {
        this.currentPage = 0;
        this.maxScrollTop = -1;
        this.fetchedAll = false;
        this.fetchingData = true;
        this.rowData = [];

        if (this.gridApi) {
            this.gridApi.setRowData([]);
            this.gridApi.redrawRows();
        }

        this.affiliateManageService
            .getAffiliates()
            .then(() => {
                this.fetchingData = false;
            });
    }

    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
        if (this.gridApi) {
            const verticalPixelRange = this.gridApi.getVerticalPixelRange();
            const { bottom = 0 } = verticalPixelRange;
            if (bottom > this.maxScrollTop + MAX_TABLE_HEIGHT) {
                this.maxScrollTop = bottom;
                this.fetchMoreData();
            }
        }
    }

    onScrollEnd(event: any) {
        const { top = -1, direction = '' } = event;

        if (direction !== 'vertical') {
            return;
        }

        if (
            top <= MAX_TABLE_HEIGHT ||
            top > this.maxScrollTop + MAX_TABLE_HEIGHT
        ) {
            this.maxScrollTop = top;
            this.fetchMoreData();
        }
    }

    rowClicked(e) {
        console.log({ e });
        this.selectedRow = e.node;
    }

    onLoaded() {
        if (!isEmpty(this.gridApi)) {
            const verticalPixelRange = this.gridApi.getVerticalPixelRange();
            const { bottom = 0 } = verticalPixelRange;
            if (bottom > this.maxScrollTop + MAX_TABLE_HEIGHT) {
                this.maxScrollTop = bottom;
                setTimeout(() => {
                    this.fetchMoreData();
                }, 1000);
            }
        }
    }

    protected readonly async = async;
}

@Component({
    templateUrl: 'affiliate-manage-cell-renderer.html',
    styleUrls: ['./affiliate-manage.component.scss'],
})
export class AffiliateManageCellRenderer implements ICellRendererAngularComp {
    isActive: true;
    toggleStatus!: (approved: any) => void;
    params: any;

    constructor() { }

    agInit(params: any): void {
        this.isActive = params.data.activate;
        this.params = params;
        this.toggleStatus = (isActive) => {
            console.log({ isActive });
            params.toggleStatus({
                ...params.data,
                activate: isActive?.checked
            });
        }

    }

    refresh(params: ICellRendererParams): boolean {
        return false;
    }
}
